import {
  SET_CONTRIBUTION_CHOICE_ADMIN,
  SET_DATA_FIELD,
  SET_IMAGE_GROUP,
  SET_IMAGE_HEADER,
  SET_OPEN_MENU,
  SET_USER_POINT,
} from './constants';

export const setOpenMenu = (payload: any) => ({
  type: SET_OPEN_MENU,
  payload,
});

export const setImageGroup = (payload: string) => ({
  type: SET_IMAGE_GROUP,
  payload,
});

export const setUpdateHeader = () => ({
  type: SET_IMAGE_HEADER,
});

export const setDataFieldByMode = (payload: any) => ({
  type: SET_DATA_FIELD,
  payload,
});

export const setUserPoint = (payload: any) => ({
  type: SET_USER_POINT,
  payload,
});

export const setContributionChoose = (payload: any) => ({
  type: SET_CONTRIBUTION_CHOICE_ADMIN,
  payload,
});
